type Props = {
  cx?: number;
  cy?: number;
  payload?: { monthValue: number };
};

export const CustomDot = ({ cx, cy, payload }: Props) => {
  if (!cx || !cy || payload?.monthValue === 0) return <g />;

  return (
    <g>
      <circle cx={cx} cy={cy} r={8} opacity={0.25} fill="#7086FD" />
      <circle cx={cx} cy={cy} r={3.5} fill="#7086FD" stroke="white" />
    </g>
  );
};
